export const sortableKeys = [
  "screening_status",
  "status",
  "submitted_at",
  "started_at",
  "updated_at",
  "applicants",
  "desired_move_in_date"
];

export const DEFAULT_PER_PAGE = window.localStorage.getItem("per_page") || "10";

export const SESSION_STORAGE_KEY = "applications_table_query_params";

export const URL_PARAM_KEYS = [
  "search",
  "page",
  "tab",
  "per_page",
  "status",
  "properties",
  "cities",
  "units",
  "unit_types",
  "screening_statuses",
  "sort_by",
  "sort_dir",
  "group_by",
  "unit_status",
  "assignee_ids"
] as const;

export const DEFAULT_URL_PARAMS: Record<string, string> = {
  search: "",
  page: "",
  tab: "",
  per_page: "",
  status: "",
  properties: "",
  cities: "",
  units: "",
  unit_types: "",
  screening_statuses: "",
  sort_by: "",
  sort_dir: "",
  group_by: "",
  unit_status: "",
  assignee_ids: ""
};

export const DEFAULT_COLUMN_VISIBILITY = [
  { id: "criteria", label: "Criteria", checked: true, disabled: false },
  { id: "applicants", label: "Applicants", checked: true, disabled: false },
  { id: "property", label: "Property", checked: true, disabled: false },
  { id: "unit", label: "Unit", checked: true, disabled: false },
  { id: "unit_type", label: "Unit type", checked: false, disabled: false },
  {
    id: "started_at",
    label: "Started Date/Time",
    checked: true,
    disabled: false
  },
  {
    id: "last_note",
    label: "Last Note",
    checked: true,
    disabled: true
  },
  {
    id: "submitted_at",
    label: "Submitted Date/Time",
    checked: true,
    disabled: false
  },
  {
    id: "desired_move_in_date",
    label: "Move-in date",
    checked: false,
    disabled: false
  },
  { id: "updated_at", label: "Updated at", checked: false, disabled: false },
  { id: "assigned_to", label: "Assigned to", checked: true, disabled: false },
  { id: "status", label: "Status", checked: true, disabled: false },
  {
    id: "property_group",
    label: "Property group",
    checked: false,
    disabled: false
  }
];
